import { cn } from "@/lib/utils";
import { formatNumber } from "@/lib/utils";
import { HighlightedValueChange } from "./highlightedValueChange";

interface BalanceIndicatorProps {
  buyLevels: number;
  sellLevels: number;
  buyVolume: number;
  sellVolume: number;
  className?: string;
}

export function BalanceIndicator({
  buyLevels,
  sellLevels,
  buyVolume,
  sellVolume,
  className,
}: BalanceIndicatorProps) {
  const totalLevels = buyLevels + sellLevels;
  const buyLevelsPercentage =
    totalLevels > 0 ? (buyLevels / totalLevels) * 100 : 50;
  const sellLevelsPercentage = 100 - buyLevelsPercentage;

  return (
    <div
      className={cn(
        "relative text-xs min-w-[200px] flex items-center",
        className,
      )}
    >
      <div className="absolute inset-0 flex">
        <div
          className="h-full bg-green-500/10"
          style={{ width: `${buyLevelsPercentage}%` }}
        />
        <div
          className="h-full bg-red-500/10"
          style={{ width: `${sellLevelsPercentage}%` }}
        />
      </div>
      <div className="relative z-10 w-full flex justify-between items-center px-2">
        <div className="flex items-baseline gap-1">
          <HighlightedValueChange
            value={buyLevels}
            highlightNewTextColor={false}
            shorten={true}
            decimal={0}
            className="text-xs font-medium"
          />
          <span className="text-xs text-muted-foreground">
            (
            {
              <HighlightedValueChange
                value={buyVolume}
                highlightNewTextColor={false}
                shorten={true}
                decimal={0}
                className="text-xs font-medium"
              />
            }
            )
          </span>
        </div>
        <div className="flex gap-1 text-xs text-muted-foreground">
          <span>{buyLevelsPercentage.toFixed(1)}%</span>
          <span>/</span>
          <span>{sellLevelsPercentage.toFixed(1)}%</span>
        </div>
        <div className="flex items-baseline gap-1">
          <span className="text-xs text-muted-foreground">
            (
            {
              <HighlightedValueChange
                value={sellVolume}
                highlightNewTextColor={false}
                shorten={true}
                decimal={0}
                className="text-xs font-medium text-red-600"
              />
            }
            )
          </span>
          <HighlightedValueChange
            value={sellLevels}
            highlightNewTextColor={false}
            className="text-xs font-medium text-red-600"
          />
        </div>
      </div>
    </div>
  );
}
